import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MXIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MX" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#D9071E"
        fillRule="evenodd"
        d="M11.2 0H16v12h-4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#006923"
        fillRule="evenodd"
        d="M0 0h4.8v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        fillRule="evenodd"
        d="M4.8 0h6.4v12H4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FCCA3D"
        fillRule="evenodd"
        d="M7.192 3.957s-.343.266-.28.55c.065.284.742 0 .66-.275-.082-.275-.38-.275-.38-.275Z"
        clipRule="evenodd"
      />
      <Path
        fill="#A8AC71"
        d="M7.008 3.974a2.864 2.864 0 0 0-.11.197c.09.027.18.066.251.113.233.154.32.428.07.631a.815.815 0 0 0-.171.302c.119.007.204.025.283.071.22.131.2.369.032.553-.12.13-.279.237-.429.291-.25.09-.516.056-.516-.264 0-.012-.008-.037.11-.04-.19-.002-.231-.104-.255-.283a1.856 1.856 0 0 1-.012-.181l-.004-.12c-.004-.065-.017-.11.122-.11h-.29v-.5h.29c.164 0 .255.054.307.169a1.26 1.26 0 0 1 .094-.146.385.385 0 0 0-.112-.023c-.257 0-.364-.214-.31-.441.028-.122.1-.277.22-.477l.43.258Zm-.48 1.854h.022-.022Zm.458-.316.005-.004.003-.004-.008.008Z"
      />
      <Path
        fill="#8F4620"
        fillRule="evenodd"
        d="M9.633 6.202s.463-1.371-.273-2.08c-.735-.71-1.584-.663-1.584-.663s-.245.182 0 .32c.244.14.142.272.142.272s-.41-.416-.682-.173c-.272.243.254.206.198.39-.055.182-.291.995.054 1.405.344.41-.326.321-.19.321s.62.096.62 0c0-.095.168.372.312.372s.255-.164.255-.164.201.164.324.164.551-.108.551-.108l-.81-.682s.05-.301-.065-.366.92.577 1.002.784c.08.208.146.208.146.208Z"
        clipRule="evenodd"
      />
      <Path
        fill="#9FAB2F"
        d="M5.533 5.863s.075-.239.156-.256c.07-.014.216.115.216.115.26 1.445.889 2.01 1.932 2.01 1.056 0 1.696-.43 2.07-1.762 0 0 .198-.203.268-.18.077.024.172.292.172.292-.428 1.53-1.238 2.21-2.51 2.21-1.284 0-2.005-.77-2.304-2.429Z"
      />
      <Path
        fill="#2FC2DC"
        fillRule="evenodd"
        d="M6.667 6.828s1.502.319 2.095.319c.593 0-.52.484-.954.484-.435 0-1.14-.803-1.14-.803Z"
        clipRule="evenodd"
      />
      <Rect
        width={1}
        height={0.536}
        x={7.333}
        y={7.05}
        fill="#F9AA51"
        rx={0.083}
      />
      <Path
        fill="#259485"
        d="m6.088 6.068.41-.287c.532.76 1.328 1.009 2.443.748l.114.487c-1.303.305-2.31-.01-2.967-.948Z"
      />
      <Path
        fill="#FCCA3D"
        fillRule="evenodd"
        d="M8.296 6.175s-.607.32-.405.32c.202 0 .994.16.84 0-.154-.16-.435-.32-.435-.32ZM7.578 5.794s-.115-.333-.355-.333-.172.273-.288.273c-.115 0 .108.193.207.193.1 0 .436-.133.436-.133Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
